export default class Users {
    id: number
    userRoleId: number
    userGroupId: number
    userGroupName: string
    personalNr: string
    firstname: string
    lastname: string
    birthdate: Date
    internalEmployee: boolean
    registered: boolean
    deactivationDate: Date
    deactivatedBy: number
    active: boolean
    email: string
    phone: string
    plz: string
    password: string
    [key: string]: any
}